import api, { Base, Tags } from 'ev-api/api';

import { CdxProxyEnvelope } from './module-types';

export type CdxCustomer = {
  id: number;
  name: string;
  description?: string | null;
  handle: string;
  owner_type?: string | null;
  owner_identifier?: string | null;
};

export type ListCdxCustomersParams = {
  ownerType: string;
  ownerIdentifier: string;
};

export type CreateCdxCustomerParams = {
  name: string;
  handle?: string;
  owner_type: string;
  owner_identifier: string;
  description?: string;
};

const cdxCustomersApi = api.injectEndpoints({
  endpoints: builder => ({
    listCdxCustomers: builder.query<CdxCustomer[], ListCdxCustomersParams>({
      query: ({ ownerType, ownerIdentifier }) => ({
        url: `${Base.V4}/cdx_proxy/config/customers`,
        params: {
          'filter[owner_type]': ownerType,
          'filter[owner_identifier]': ownerIdentifier,
        },
      }),
      transformResponse: (response: CdxProxyEnvelope<CdxCustomer[]>) => {
        const data = response.data;
        return Array.isArray(data) ? data : [];
      },
      providesTags: [Tags.CdxCustomers],
    }),

    createCdxCustomer: builder.mutation<CdxCustomer, CreateCdxCustomerParams>({
      query: customer => ({
        url: `${Base.V4}/cdx_proxy/config/customers`,
        method: 'POST',
        body: { customer },
      }),
      transformResponse: (response: CdxProxyEnvelope<CdxCustomer>) =>
        response.data,
      invalidatesTags: [Tags.CdxCustomers],
    }),
  }),
});

export const { useListCdxCustomersQuery, useCreateCdxCustomerMutation } =
  cdxCustomersApi;
